import $ from "jquery";
import Global from '../common/global';
import { Basket } from "../common/basket";
import { MapHelper } from '../common/mapHelper';
import { initDisappearingButton } from '../common/mobileButtons';
import { Modal } from 'bootstrap';
import Swiper from 'swiper';
import { FreeMode, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { SheetHelper } from "../common/sheetHelper";
import { initCalendar, initHotelCalendar, initNoDatesCalendar } from '../common/calendar';
import { initSearchBarFields, initSearchOptionClick, initMobileSearchbarToggle, initSearchDropdownHandler, initHotelChangeSearch } from '../common/searchBarFields';
import { SearchRoomManager } from '../common/searchRoomManager';
import { TransferHelper } from './../common/transferHelper';
import { showSnackbar } from '../common/snackBar';
import { initCollapsible } from '../common/collapsible';

let loginModalDismissed = false;
let memberModal: Modal | null = null;
let memberModalEl: HTMLElement | null = null;

// Initialize the map (from your external helper)
MapHelper.initMainMap('mainMap');

initDisappearingButton('#btnSelectARoom', '#hotelInfoRooms');

// Tell TypeScript about the global variable
declare global {
    interface Window {
        isLoggedIn: boolean;
        isCallCentreMode: boolean;
    }
}
const isLoggedIn = window.isLoggedIn;
const isCallCentreMode = window.isCallCentreMode;

const basket = new Basket();

document.addEventListener("db-counter-updated", (e: any) => {
    const buttonRef: JQuery<HTMLElement> = e.detail.buttonRef;

    // Only proceed if button is inside .db-rooms-selection
    if (buttonRef.hasClass("rooms-counter") && !buttonRef.closest('.db-rooms-selection').length) {
        return;
    }
    
    if (buttonRef.hasClass("rooms-counter") && !isLoggedIn && !isCallCentreMode && !loginModalDismissed) {
        // Find the closest .db-room-card
        const roomCard = buttonRef.closest('.db-room-card');
        const memberPrice = roomCard?.data('member-price-display');
        const nonMemberPrice = roomCard?.data('price-display');

        showMemberModal(() => {
            processCounterClick(buttonRef);
        }, memberPrice, nonMemberPrice);
        return;
    }
    
    processCounterClick(buttonRef);
});

$(document).on('click', '.db-member-price', function (this: HTMLElement, event: JQuery.ClickEvent) {
    if (!isLoggedIn && !isCallCentreMode && !loginModalDismissed) {
        const buttonRef: JQuery<HTMLElement> = $(this);
        const roomCard = buttonRef.closest('.db-room-card');
        const memberPrice = roomCard?.data('member-price-display');
        const nonMemberPrice = roomCard?.data('price-display');
        showMemberModal(() => { }, memberPrice, nonMemberPrice, true, true);
    }
});

$(document).on('click', '#btnAddToBasket', function (this: HTMLElement, event: JQuery.ClickEvent) {
    const pageRef = $(this).data('page-ref');
    const buttonRef = $(this); // jQuery object for the clicked button

    basket.addToBasket(buttonRef, pageRef);
});

function initMobileBasket(): void {
    document.addEventListener("click", (e: MouseEvent) => {
        const target = e.target as HTMLElement;
        const mobileBasketPrice = target.closest(".db-selected-rooms-price");

        if (mobileBasketPrice) {
            const container = mobileBasketPrice.closest(".db-selected-rooms") as HTMLElement;
            const chevron = mobileBasketPrice.querySelector("i.fa-chevron-up") as HTMLElement;

            if (container) {
                // Toggle peek/show classes
                container.classList.toggle("peek");
                container.classList.toggle("show");
            }

            if (chevron) {
                // Rotate the chevron
                chevron.classList.toggle("rotated");
            }
        }
    });
}

function initShare(): void {
    document.addEventListener("click", (e: MouseEvent) => {
        // No native share so use our own custom built one
        const target = e.target as HTMLElement;
        const shareButton = target.closest(".btn-share");

        if (shareButton) {
            if (typeof navigator.share === "function") {
                // Native share on device
                try {
                    navigator.share({
                        title: "Getaways",
                        text: `Hey, check out this amazing hotel deal from Getaways Ireland. You can save as much as 15% per night on their hotel deals and earn cashback when you book!`,
                        url: window.location.href
                    });
                } catch (err) {
                    console.log("Sharing cancelled or failed:", err);
                }
            } else {
                const shareButton = target.closest(".btn-share");
                if (shareButton) {
                    const container = shareButton.closest(".share-container");
                    if (container) {
                        container.classList.toggle("open");
                    }
                }
            }
        } else {
            // Close all open dropdowns if clicking outside
            document.querySelectorAll(".share-container.open").forEach(container => {
                const shareicon = target.closest(".share-icon");
                if (!container.contains(target) || shareicon) {
                    container.classList.remove("open");
                }
            });
        }
    });

    // Copy link
    document.querySelector('a.link.share-icon')?.addEventListener('click', function (e) {
        e.preventDefault();

        const url = new URL(window.location.href);
        url.searchParams.set('utm_source', 'share');
        url.searchParams.set('utm_medium', 'social');
        url.searchParams.set('utm_campaign', 'hotel-share');

        navigator.clipboard.writeText(url.toString())
            .then(() => showSnackbar("Success!", `URL copied to clipboard!`))
            .catch(() => showSnackbar("Error!", "Failed to copy URL!"));
    });
}

function initReviewsLink(): void {
    document.addEventListener("click", (e: MouseEvent) => {
        // No native share so use our own custom built one
        const target = e.target as HTMLElement;
        const reviewsLink = target.closest(".review-open");

        if (reviewsLink) {
            const infoSection = document.querySelector(".db-hotel-info-right");
            if (infoSection) {
                infoSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        } 
    });
}

function initHotelGalleryModal(): void {
    const modal = document.getElementById('hotel-gallery-modal');
    // 1. Get all gallery items (images + the last overlay wrapper)
    const galleryItems = document.querySelectorAll<HTMLElement>('.db-hotel-gallery .gallery-row img, .db-hotel-gallery .gallery-overlay-wrapper');
    const swiperContainer = modal?.querySelector('.hotel-swiper');

    if (!modal || !galleryItems.length || !swiperContainer) {
        console.warn('Gallery elements not found');
        return;
    }

    let swiper: Swiper | null = null;

    galleryItems.forEach((item, index) => {
        item.addEventListener('click', () => {
            modal.classList.remove('hidden');

            if (!swiper) {
                swiper = new Swiper('.hotel-swiper', {
                    modules: [Navigation, Pagination],
                    loop: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: { el: '.swiper-pagination', clickable: true },
                });
            } else {
                swiper.update();
            }

            // Determine the correct slide index
            let slideIndex = index;
            if (item.classList.contains('gallery-overlay-wrapper')) {
                const img = item.querySelector<HTMLImageElement>('img');
                if (img) {
                    const allImages = Array.from(document.querySelectorAll('.db-hotel-gallery img'));
                    slideIndex = allImages.indexOf(img);
                }
            }

            swiper.slideTo(slideIndex, 0); // jump to clicked image
        });
    });

    const modalClose = document.querySelector(".close-gallery");
    if (modalClose) {
        modalClose.addEventListener('click', () => {
            modal.classList.add('hidden');
        });
    }
}

function initSelectedRoomsSidebar() {
    var firstRoom = document.querySelector<HTMLElement>('.db-room-card')!;
    if (!firstRoom) {
        firstRoom = document.querySelector<HTMLElement>('.db-no-selected-dates')!;

        if (!firstRoom) {
            firstRoom = document.querySelector<HTMLElement>('.db-no-rooms-available')!;
        }
    }

    var roomsContainer = document.querySelector<HTMLElement>('#hotelInfoRoomResults');

    const sidebar = document.querySelector<HTMLElement>('.db-selected-rooms-container')!;

    const laptopBreakpoint = 992;

    function updatePosition() {
        if (window.innerWidth < laptopBreakpoint) {
            // Mobile: bottom sheet handled by CSS
            sidebar.style.position = '';
            sidebar.style.top = '';
            sidebar.style.width = '';
            return;
        }

        // Absolute top of the first room card relative to document
        const scrollY = window.scrollY || window.pageYOffset;

        const sidebarRect = sidebar.getBoundingClientRect();

        const roomsContainerRect = roomsContainer?.getBoundingClientRect();
        const roomsContainerTop = roomsContainerRect!.top + scrollY;

        // Parent (right column) top relative to document
        const rightColumn = sidebar.parentElement!;
        const rightTop = rightColumn.getBoundingClientRect().top + scrollY;

        const containerTopRelativeToRight = roomsContainerTop - rightTop;
        const containerBottomRelativeToRight = containerTopRelativeToRight + roomsContainerRect!.height - sidebarRect.height;

        const docScrollY = document.body.scrollTop;

        const scrollStartOffset = firstRoom.getBoundingClientRect().height;

        var finalTop = containerTopRelativeToRight;
        const scrollYWithOffset = docScrollY - scrollStartOffset;

        if (docScrollY > containerTopRelativeToRight + scrollStartOffset) {
            // Calculate the effective bottom limit considering the offset
            const adjustedBottom = containerBottomRelativeToRight;

            if (scrollYWithOffset > adjustedBottom) {
                finalTop = adjustedBottom;
            } else {
                finalTop = scrollYWithOffset;
            }
        }

        sidebar.style.position = 'absolute';
        sidebar.style.top = `${finalTop}px`;
        sidebar.style.width = '100%';
    }

    document.body.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);
    window.addEventListener('load', updatePosition);

    updatePosition(); // initial call
}

// Extract basket logic into a reusable function
function processCounterClick(buttonRef: JQuery<HTMLElement>) {
    if (buttonRef.hasClass("rooms-counter")) {
        basket.updateRooms(buttonRef);
    } else if (buttonRef.hasClass("addon-counter")) {
        basket.updateAddOns(buttonRef);
    }
}

function showMemberModal(onClose?: () => void, memberPrice?: string, nonMemberPrice?: string, ignoreModalDismissed?: boolean, isClosable?: boolean) {
    // Prices are the same, skip modal but still run callback - we aren't doing member pricing
    //if (memberPrice == nonMemberPrice) {
    //    if (onClose) onClose();
    //    return;
    //}

    // If modal should not show but we have a callback, call it immediately
    if (!memberModalEl || !memberModal || (!ignoreModalDismissed && loginModalDismissed)) return;

    // Populate modal price spans
    const memberPriceDisplay = memberModalEl.querySelector("#memberPriceDisplay");
    const nonMemberPriceDisplay = memberModalEl.querySelector("#nonMemberPriceDisplay");

    if (memberPriceDisplay && memberPrice) memberPriceDisplay.textContent = memberPrice;
    if (nonMemberPriceDisplay && nonMemberPrice) nonMemberPriceDisplay.textContent = nonMemberPrice;

    // Add returnUrl to buttons
    const currentPath = window.location.pathname + window.location.search;
    const encodedReturnUrl = encodeURIComponent(currentPath);

    const loginBtn = memberModalEl.querySelector('#memberModalLoginButton');
    const registerBtn = memberModalEl.querySelector('#memberModalRegisterLink');

    if (loginBtn instanceof HTMLElement) {
        loginBtn.setAttribute('href', `/Account/Login?returnUrl=${encodedReturnUrl}`);
    }
    if (registerBtn instanceof HTMLElement) {
        registerBtn.setAttribute('href', `/Account/Register?returnUrl=${encodedReturnUrl}`);
    }

    const closeBtn = memberModalEl.querySelector(".modal-close") as HTMLElement | null;
    if (closeBtn) {
        if (isClosable) {
            closeBtn.classList.remove("hidden")
        } else {
            closeBtn.classList.add("hidden")
        }                    ;
    }
    
    // Set modal close behavior
    const bsModalOptions: Partial<bootstrap.Modal.Options> = isClosable
        ? { backdrop: true, keyboard: true }
        : { backdrop: 'static' as const, keyboard: false };

    // Re-initialize modal with the correct close settings
    memberModal.dispose(); // destroy previous instance if exists
    memberModal = new Modal(memberModalEl, bsModalOptions);

    memberModal.show();

    const notInterestedBtn = memberModalEl.querySelector("#notInterestedBtn") as HTMLElement | null;
    if (notInterestedBtn) {
        notInterestedBtn.addEventListener("click", () => {
            if (!ignoreModalDismissed) loginModalDismissed = true;
            memberModal?.hide();
            if (onClose) onClose();
        });
    }

    memberModalEl.addEventListener("hidden.bs.modal", () => {
        if (!ignoreModalDismissed) loginModalDismissed = true;
        if (onClose) onClose();
    }, { once: true });
}

function initSeeMoreToggles(): void {
    document.querySelectorAll(".see-more-btn").forEach(btn => {
        // Find the collapsible element just before the button
        const collapsible = btn.previousElementSibling;
        if (!collapsible) return;

        btn.addEventListener("click", () => {
            const isCollapsed = collapsible.classList.toggle("collapsed");
            btn.textContent = isCollapsed ? "Read more" : "Read less";
        });
    });
}

function performSort(field: string, direction: string): void {
    const container = document.querySelector<HTMLElement>('.review-list-wrapper');
    if (!container) return;

    const reviewNodes = Array.from(container.querySelectorAll<HTMLElement>('.db-review-card'));

    reviewNodes.sort((a, b) => {
        const aValue = Number(a.getAttribute(field));
        const bValue = Number(b.getAttribute(field));

        if (direction === 'asc') {
            return aValue - bValue;
        } else {
            return bValue - aValue;
        }
    });

    // Re-append them in sorted order
    reviewNodes.forEach(node => container.appendChild(node));
}

function initReviewsSheet(): void {
    // Sorting logic
    const sortSelect = document.querySelector<HTMLSelectElement>('#ReviewSort');
    if (sortSelect) {
        sortSelect.addEventListener('change', () => {
            const selectedOption = sortSelect.options[sortSelect.selectedIndex];
            const sortField = selectedOption.getAttribute('data-sort-option');
            const sortDir = selectedOption.getAttribute('data-sort-dir');
  
            if (sortField && sortDir) {
                performSort(sortField, sortDir);
            }
        });
    }

    // Attach click listener to document (or a common parent of buttons)
    document.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;

        // Check if the clicked element is the button OR inside the button
        const btn = target.closest<HTMLButtonElement>('.btn-open-reviews');
        if (!btn) return;

        const currentSheet = document.querySelector<HTMLElement>(".reviews-sheet");
        if (!currentSheet) return;

        SheetHelper.closeOtherSheets(currentSheet);
        SheetHelper.toggleSheet(currentSheet);
    });

    // Filters button tp close sheet (Apply)
    const closeBtn = document.querySelector<HTMLButtonElement>('.btn-close-reviews');
    closeBtn?.addEventListener('click', () => {
        const sheet = document.querySelector<HTMLElement>(".reviews-sheet");
        if (sheet) {
            SheetHelper.closeSheet(sheet);
        }
    });
}

function setupMap(): void {
    const map = document.getElementById("mainMap");
    if (!map) return;

    MapHelper.toggleMapControls(map.classList.contains("full-screen"));

    const toggleFullScreen = (isFullScreen: boolean) => {
        map.classList.toggle("full-screen", isFullScreen);

        const buttonHtml = isFullScreen
            ? `<button type="button" class="db-button db-button--primary btn-close-map">Close Map <i class="icon-x"></i></button>`
            : `<button type="button" class="db-button db-button--primary btn-show-on-map">Show on Map</button>`;

        const oldButton = map.querySelector(".db-button");
        if (oldButton) oldButton.outerHTML = buttonHtml;

        const newButton = map.querySelector(".db-button");
        newButton?.addEventListener("click", () => toggleFullScreen(!isFullScreen));

        // Tell Leaflet to recheck map size
        setTimeout(() => {
            MapHelper.mapRefresh();
        }, 300);

        // Freeze / unfreeze map interaction
        MapHelper.toggleMapControls(isFullScreen);
    };

    const initialButton = map.querySelector(".db-button");
    initialButton?.addEventListener("click", () => toggleFullScreen(true));
}

function initPointsOfInterestModal(): void {
    $(document).on('click', '.btn-show-all-poi', function (this: HTMLElement, event: JQuery.ClickEvent) {
        const modal = new Modal(document.getElementById('poiModal')!);
        modal.show();
    });
}

document.addEventListener('DOMContentLoaded', () => {

    if (sessionStorage.getItem('scrollToAvailability') === 'true') {
        sessionStorage.removeItem('scrollToAvailability');

        const el = document.getElementById('hotelInfoRooms');
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    setupMap();

    initCalendar(false);
    initHotelCalendar(false);
    initNoDatesCalendar(true);

    // Initialize the search bar fields and sheets/dropdowns
    initSearchBarFields({ desktopBreakpoint: 992 });
    initSearchDropdownHandler();
    initHotelChangeSearch();

    // Initialize search-option click handling
    initSearchOptionClick();

    initReviewsLink();

    initMobileBasket();

    initShare();

    const roomsEl = document.querySelector('#rooms');
    if (roomsEl) {
        // Example max rooms
        const maxRooms = 5;

        // Create instance
        const searchRoomManager = new SearchRoomManager(maxRooms);

        // Initialise event handlers
        searchRoomManager.init();
    }

    initMobileSearchbarToggle();

    // Member Modal
    memberModalEl = document.getElementById("memberPromptModal");
    if (memberModalEl) {
        memberModal = new Modal(memberModalEl, {
            backdrop: "static", // prevents closing by clicking outside
            keyboard: false     // prevents closing with Esc key
        });
    }

    initCollapsible();

    initHotelGalleryModal();

    initSeeMoreToggles();

    initSelectedRoomsSidebar();

    initPointsOfInterestModal();

    const reviewSwiperContainer = document.querySelector<HTMLElement>('.reviews-swiper');

    if (!reviewSwiperContainer) {
        console.warn('Reviews swiper container not found');
    } else {
        const reviewSwiper = new Swiper(reviewSwiperContainer, Global.getSwiperConfig(reviewSwiperContainer, true, {
            modules: [FreeMode],
            slidesPerView: 1.5,
            spaceBetween: 16,
            freeMode: true,

            breakpoints: {
                768: { slidesPerView: 2.75 },
                992: { slidesPerView: 1.25 }
            }
        }));
    }

    initReviewsSheet();

    // If we have a transfer button on the page init trasnfer mode
    if (document.querySelector('.btn-add-to-transfer-basket')) {
        TransferHelper.initCustomerTransferBooking();
        TransferHelper.initAddToTransferBasket();
    }
});